import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

const Item = styled.div`
  padding: 0 10px;
`;

class SocialShareSection extends React.Component {
  componentDidMount = () => {
    if (!document.getElementById('facebook-jssdk')) {
      const fjs = document.getElementsByTagName('script')[0];
      const js = document.createElement('script');
      js.id = 'facebook-jssdk';
      js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0';
      fjs.parentNode.insertBefore(js, fjs);
    }

    if (!document.getElementById('twitter-wjs')) {
      const fjs = document.getElementsByTagName('script')[0];
      this.t = window.twttr || {};
      const js = document.createElement('script');
      js.id = 'twitter-wjs';
      js.src = 'https://platform.twitter.com/widgets.js';
      fjs.parentNode.insertBefore(js, fjs);

      this.t._e = [];         // eslint-disable-line
      this.t.ready = f => {
        this.t._e.push(f);    // eslint-disable-line
      };
    }
  };

  render = () => (
    <Section>
      <Item>
        <div
          className="fb-share-button"
          data-href={window.location.href}
          data-layout="button"
          data-mobile-iframe="false"
          data-size="large"
        >
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse"
            className="fb-xfbml-parse-ignore"
          >
            Share
          </a>
        </div>
      </Item>

      <Item>
        <a className="twitter-share-button" href={window.location.href} data-size="large">
          Tweet
        </a>
      </Item>
    </Section>
  );
}

export default SocialShareSection;



// WEBPACK FOOTER //
// ./src/components/SocialShareSection/SocialShareSection.js